module.exports = __webpack_public_path__ + "img/拆单.55120d69.svg";